import { Input, Flex as WebFlex } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { PDFOnly } from '../../../summary/components/PDFOnly.tsx';
import { Typography } from '../../../summary/components/Typography.tsx';
import { WebOnly } from '../../../summary/components/WebOnly.tsx';
import { SummarySection } from '../SummarySection.tsx';
import { SummaryTableHorizontal } from '../SummaryTableHorizontal.js';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { calculations } from '../utils/formatters/calculations.ts';
import { PairedCostSettingsBreakdown } from './PairedCostSettingsBreakdown.tsx';
import { isCosted } from './isCosted.ts';

export const AdjustmentBreakdownPatioDeck = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  const commentaryProps = props.exportableCommentaries.porchPatioDeck;
  const [commentary, setCommentary] = useState(commentaryProps.commentary);

  if (!isCosted(props.results, 'porchPatioDeck')) {
    return null;
  }
  return (
    <SummarySection>
      <TitleAndExportToggleLockup
        {...props}
        title="Porch / Patio / Deck Adjustment"
        id="isPatioDeckCommentaryInExport"
        commentary={commentaryProps}
      />
      <Typography variant="body1">
        The patio/deck adjustment is calculated by subtracting the comparable’s patio and/or deck
        value from the subject’s patio and/or deck value.
      </Typography>
      <PDFOnly>
        <Typography variant="body1">{commentaryProps.commentary}</Typography>
      </PDFOnly>
      <SummaryTableHorizontal
        {...props}
        compSequence={props.compSequence}
        summary={props}
        columns={[
          {
            header: 'Porch/Patio/Deck',
            type: 'feature',
            adjustmentType: 'porchPatioDeck',
            path: 'text',
          },
          {
            header: 'Square Feet',
            type: 'feature',
            adjustmentType: 'porchPatioDeck',
            path: 'sqft',
          },
          {
            header: 'Adjustment Calculation',
            type: 'adjustment',
            adjustmentType: 'porchPatioDeck',
            path: 'calculations',
            valueFormatter: calculations,
          },
          {
            header: 'Adjustment',
            path: 'adjustment',
            adjustmentType: 'porchPatioDeck',
            type: 'adjustment',
            valueFormatter: adjustment,
            textAlign: 'right',
            includeTooltip: true,
          },
        ]}
      />
      <PairedCostSettingsBreakdown {...props} type="porchPatioDeck" />
      <WebOnly>
        <WebFlex marginTop="1rem" width="40rem">
          <Input
            type="multiline"
            onChange={setCommentary}
            value={commentary}
            onClear={() => setCommentary('')}
            onBlur={() => commentaryProps.updateCommentary(commentary)}
            resize="both"
            label="Commentary"
            size="sm"
          />
        </WebFlex>
      </WebOnly>
    </SummarySection>
  );
};
